import { render, staticRenderFns } from "./LogoSemColor.vue?vue&type=template&id=42205398&"
import script from "./LogoSemColor.vue?vue&type=script&lang=js&"
export * from "./LogoSemColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports